import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { OPERATOR_FLOW_ICONS } from '../../operatorNavigation';
import {
  OPERATOR_FLOW,
  OPERATOR_FLOW_LABELS,
  OPERATOR_FLOW_PATHS,
} from '../../../../features/operator/operatorConstants';
import {
  queueSummary,
  selectCurrentOperatorWarehouse,
  selectShownFlows,
} from '../../../../features/operator/operatorUtils';
import { selectTaskQueues } from '../../../../features/operatorTasks/operatorTasksSlice';

/** What a station without a queue says under its name. */
const STATION_CAPTIONS = {
  [OPERATOR_FLOW.KITS]: 'Armar y desarmar',
  [OPERATOR_FLOW.STOCK]: 'Qué es un código',
};

const FlowCard = ({ flow, queues }) => {
  const Icon = OPERATOR_FLOW_ICONS[flow];
  const summary = queueSummary(flow, queues);
  return (
    <Link
      to={OPERATOR_FLOW_PATHS[flow]}
      data-testid="flow-card"
      data-flow={flow}
      data-count={summary?.count ?? ''}
      className="flex min-h-[132px] flex-col justify-between rounded-2xl border border-border bg-white p-4 shadow-sm transition-colors hover:border-ninja-green active:bg-ninja-gray dark:bg-[#1a1a1a] dark:active:bg-[#222]"
    >
      <span className="flex items-center justify-between">
        <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-ninja-green text-white">
          <Icon size={22} />
        </span>
        {summary && <span className="text-3xl font-bold text-ninja-dark dark:text-white">{summary.count}</span>}
      </span>
      <span>
        <span className="block text-base font-bold text-ninja-dark dark:text-white">{OPERATOR_FLOW_LABELS[flow]}</span>
        <span className="block text-xs text-text-secondary">{summary ? summary.caption : STATION_CAPTIONS[flow] ?? ''}</span>
      </span>
    </Link>
  );
};

/**
 * Trabajo libre: a station per flow open here, in floor order, each with
 * what waits in its queue. The tray counts them once it came; until then, or
 * if it failed, `me` does.
 */
export const HomeStations = () => {
  const warehouse = useSelector(selectCurrentOperatorWarehouse);
  const flows = useSelector(selectShownFlows);
  const trayQueues = useSelector(selectTaskQueues);
  const queues = trayQueues ?? warehouse?.queues ?? null;

  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-3">
      {flows.map((flow) => (
        <FlowCard key={flow} flow={flow} queues={queues} />
      ))}
    </div>
  );
};
